export default __webpack_public_path__ + "static/media/throw.d06fc32d.mp3";